import script from "./dynamic-table.vue?vue&type=script&lang=tsx&setup=true"
export * from "./dynamic-table.vue?vue&type=script&lang=tsx&setup=true"

import "./dynamic-table.vue?vue&type=style&index=0&id=67ce3842&lang=less&scoped=true"
import "./dynamic-table.vue?vue&type=style&index=1&id=67ce3842&scoped=true&lang=css"
import "./dynamic-table.vue?vue&type=style&index=2&id=67ce3842&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ce3842"]])

export default __exports__